import { render, staticRenderFns } from "./layout-home.vue?vue&type=template&id=a613fff4&scoped=true"
import script from "./layout-home.vue?vue&type=script&lang=js"
export * from "./layout-home.vue?vue&type=script&lang=js"
import style0 from "./layout-home.vue?vue&type=style&index=0&id=a613fff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a613fff4",
  null
  
)

export default component.exports